import React, { useState, useEffect, useRef } from "react";

import {
    Box,
    Chip,
    Paper,
    TextField,
    Grid,
    styled,
    Card,
    Divider,
    Table,
    TableContainer,
    TableHead,
    TableCell,
    Checkbox,
    TableRow,
    TableBody,
    Button,
    Typography,
    InputAdornment,
    FormControlLabel,
    Link
} from '@mui/material';

import * as Yup from "yup";

import dayjs from "dayjs";

import { grey, red } from "@mui/material/colors";

import {
    DataGrid,
    GridColDef,
    GridToolbar,
    GridCellParams,
    useGridApiContext,
    GridCellEditStopReasons
} from '@mui/x-data-grid';

import { useFormik } from 'formik';

import { useSystemRoutes, routeTypes } from '../../../../../../hooks/useSystemRoutes';

import { useProduct, productInjectionFields, productLoadStatusTypes } from "../../../../hooks/model/useProduct"
import { useContainerItem } from "../../../../hooks/model/useContainerItem"
import { useContainer, containerInjectionProps } from "../../../../hooks/model/useContainer"
import {
    useProductItem,
    validateSchema as _validateItemSchema,
    initialValues as _initialItemValues,
    itemInjectionProps
} from "../../../../hooks/model/useProductItem"

import { useAuthAccess } from "../../../../../../hooks/useAuthAccess";

import { CommonIcons, icons } from "../../../../../../components/common/CommonIcons";
import CommonSectionHeader from "../../../../../../components/common/CommonSectionHeader";

import { useSystemPrompt } from "../../../../../../hooks/useSystemPrompt"
import { useTranslations } from "../../../../../../hooks/useTranslations";
import { useAppContextFeatures } from "../../../../../../context/AppContext";
import { mergeSchema } from "../../../../../../utils/dataSchema"

import { getInjectionDataType } from "../../../../utils/injectionSelection";

import { getColumnsDefault, getColumnsGZ } from "./AddContainerItemsColumns";

export const validationSearchSchema = Yup.object({
    keyword: Yup
        .string()
        .required("Required"),
})

export const initialSearchValues = {
    keyword: "",
}

const validateItemSchema = mergeSchema(
    _validateItemSchema,
    Yup.object().shape({
        loadQty: Yup.lazy((val) => {

            let maxQty = val?.maxQty ? val.maxQty : 0

            let inputQtySchema;

            if (parseFloat(maxQty) > 0) {
                inputQtySchema = Yup
                    .number("")
                    .typeError("Invalid")
                    // .min(parseFloat(minQty))
                    .max(parseFloat(maxQty), `Max : ${maxQty}`)
                    .min(0, `Min : 0`)
                    // .positive("More than 0")
                    .required("Required")
            } else {
                inputQtySchema = Yup
                    .number("")
                    .typeError("Invalid")
                    // .min(parseFloat(minQty))
                    // .max(parseFloat(maxQty), `Max : ${maxQty}`)
                    // .min(0, `Min : 0`)
                    // .positive("More than 0")
                    .required("Required")
            }

            return Yup.object().shape({
                inputQty: inputQtySchema,
                maxQty: Yup.mixed().nullable().typeError("Invalid")
            })

        })
    })
);

const initialItemValues = {
    ..._initialItemValues,
    loadQty: {
        maxQty: 0,
        inputQty: ''
    },
    loadRemark: ""
}

const validateSchema = Yup.object().shape({
    items: Yup.array().of(validateItemSchema)
})

const initialValues = {
    container: {},
    items: [],
    containerItems: []
}

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

export const StyledIcon = styled(Box)({
    width: 20,
    height: 20,
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
});

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
    border: 1,
    // color:
    //     theme.palette.mode === 'light' ? 'rgba(0,0,0,.85)' : 'rgba(255,255,255,0.85)',
    // fontFamily: [
    //     '-apple-system',
    //     'BlinkMacSystemFont',
    //     '"Segoe UI"',
    //     'Roboto',
    //     '"Helvetica Neue"',
    //     'Arial',
    //     'sans-serif',
    //     '"Apple Color Emoji"',
    //     '"Segoe UI Emoji"',
    //     '"Segoe UI Symbol"',
    // ].join(','),
    // WebkitFontSmoothing: 'auto',
    // letterSpacing: 'normal',
    '& .MuiDataGrid-columnsContainer': {
        backgroundColor: theme.palette.mode === 'light' ? '#fafafa' : '#1d1d1d',
    },
    // '& .MuiDataGrid-iconSeparator': {
    //     display: 'none',
    // },
    '& .MuiDataGrid-columnHeader, .MuiDataGrid-cell': {
        borderRight: `1px solid ${theme.palette.mode === 'light' ? '#f0f0f0' : '#303030'
            }`,
    },
    '& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell': {
        borderBottom: `1px solid ${theme.palette.mode === 'light' ? '#f0f0f0' : '#303030'
            }`,
    },
    '& .MuiDataGrid-cell': {
        color:
            theme.palette.mode === 'light' ? 'rgba(0,0,0,.85)' : 'rgba(255,255,255,0.65)',
    },
    // '& .MuiPaginationItem-root': {
    //     borderRadius: 0,
    // },
    // ...customCheckbox(theme),
}));

const RenderFormSearchMarking = ({ t, formik }) => {

    const { errors, values, handleChange, handleSubmit } = formik

    return (
        <form onSubmit={handleSubmit}>
            <Box
                sx={{
                    py: 1,
                    px: 2
                }}
            >
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={3} alignSelf={"center"}>

                        <CommonSectionHeader
                            title={t('customerMarking')}
                            subTitle={t('searchCustomerDetailsByMarking')}
                        />

                    </Grid>

                    <Grid item xs={12} sm={12} md={6}
                        display={"flex"}
                        flexDirection={"column"}
                        justifyContent={"center"}
                        alignItems={"center"}
                    >

                        <TextField
                            // disabled
                            margin="dense"
                            size="small"
                            autoFocus
                            fullWidth
                            // name={`searchKeyword`}
                            label={
                                t("searchSupplierNoOrSignedByOrMarking")
                            }
                            type="text"
                            variant="outlined"
                            name={`keyword`}
                            value={values.keyword}
                            // onChange={handleChangeSearchKeyword}
                            onChange={handleChange}
                            error={Boolean(errors?.keyword)}
                            helperText={errors?.keyword}
                            InputProps={{
                                style: {
                                    marginRight: 0,
                                    paddingRight: 0
                                },
                                endAdornment: (
                                    <InputAdornment position="end">
                                        {/* <IconButton
                                        onClick={handleSearchKeyword}
                                        edge="end">
                                        <CommonIcons
                                            name={icons.search}
                                        />
                                    </IconButton> */}
                                        <Button
                                            variant="contained"
                                            color={"primary"}
                                            type="submit"
                                        >
                                            <CommonIcons
                                                name={icons.search}
                                                sx={{ mr: 1 }}
                                            />
                                            <Typography>
                                                {t("search")}
                                            </Typography>
                                        </Button>
                                    </InputAdornment>
                                ),
                            }}
                        />

                    </Grid>
                </Grid>
            </Box>
        </form>
    )
}

const RenderFormProducts = ({ t, selectedIds, columns, dataAvailableProducts, handleRowSelectionModelChange }) => {

    // let _containerId = containerId

    // get the state products and update info
    // let _dataProducts = dataProducts

    return (
        <Box
            sx={{
                py: 1,
                px: 2
            }}
        >
            <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={12} alignSelf={"center"}>

                    <Box
                        sx={{
                            height: 350,
                            width: '100%'
                        }}
                    >
                        <StyledDataGrid
                            sx={{
                                borderColor: grey[300],
                                borderStyle: 'solid',
                                borderWidth: 1,
                                p: 0.5
                            }}
                            rows={dataAvailableProducts}
                            columns={columns}
                            header
                            initialState={{
                                pagination: {
                                    paginationModel: { page: 0, pageSize: 100 },
                                },
                            }}
                            pageSizeOptions={[100]}
                            checkboxSelection

                            disableColumnFilter
                            disableColumnSelector
                            disableDensitySelector
                            disableColumnMenu={Boolean(true)}
                            disableRowSelectionOnClick

                            density="compact"

                            slots={{ toolbar: GridToolbar }}
                            slotProps={{
                                toolbar: {
                                    showQuickFilter: true,
                                },
                            }}
                            // disableRowSelectionOnClick
                            rowSelectionModel={selectedIds}
                            onRowSelectionModelChange={handleRowSelectionModelChange}
                        />
                    </Box>

                </Grid>

            </Grid>
        </Box>
    )
}

const RenderFormItems = ({ t, formik, dataProducts, checkedSplitProductItems }) => {

    const { touched, errors, values, setFieldValue } = formik

    let rows = values.items

    return (
        <Box
            sx={{
                py: 1,
                px: 2
            }}
        >
            <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={12} alignSelf={"center"}
                    sx={{
                        "& .MuiTableCell-sizeSmall": {
                            // padding: "0" // <-- arbitrary value
                            px: 1,
                            py: 0
                        }
                    }}
                >
                    {/* {JSON.stringify(errors)} */}
                    <TableContainer
                    >
                        <Table
                            // sx={{ minWidth: 650 }}
                            sx={{
                                "& .MuiTableCell-root": {
                                    border: "1px solid rgba(224, 224, 224, 1)"
                                }
                            }}
                            size="small"
                            aria-label="a dense table"
                        >

                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">
                                        {t('no')}
                                    </TableCell>
                                    <TableCell>{t('model')}</TableCell>
                                    <TableCell>{t('itemName')}</TableCell>
                                    <TableCell align="right">{t('dimension')}</TableCell>
                                    <TableCell align="right">{t('weight')}</TableCell>
                                    <TableCell align="right">{t('cbm')}</TableCell>

                                    <TableCell align="right">{t('qty')}</TableCell>
                                    <TableCell align="center" width={150}>{t('loadQty')}</TableCell>

                                </TableRow>
                            </TableHead>
                            {
                                rows.map((row, index) => {

                                    const itemValues = row;
                                    let itemTouched = touched?.items
                                    let itemErrors = errors?.items

                                    if (itemTouched) {
                                        itemTouched = (itemTouched[index] !== undefined) ? itemTouched[index] : {};
                                    }

                                    if (itemErrors) {
                                        itemErrors = (itemErrors[index] !== undefined) ? itemErrors[index] : {};
                                    }

                                    let pValues = dataProducts.filter(i => i.id === itemValues?.productId)

                                    let productValues = pValues.length ? pValues[0] : {}

                                    // console.log('itemValues', itemValues)

                                    let dimension = {
                                        width: parseFloat(itemValues?.width).toFixed(2),
                                        height: parseFloat(itemValues?.height).toFixed(2),
                                        length: parseFloat(itemValues?.length).toFixed(2)
                                    }

                                    // let handleQtyPerPackage = parseFloat(itemValues?.handleQtyPerPackage).toFixed(0)
                                    // let uomPrice = parseFloat(itemValues?.uomPrice).toFixed(2)
                                    // let handleQty = parseFloat(itemValues?.handleQty).toFixed(0)
                                    let weight = parseFloat(itemValues?.weight).toFixed(4)
                                    let qty = parseFloat(itemValues?.qty).toFixed(0)
                                    let cbm = parseFloat(itemValues?.cbm).toFixed(4)

                                    let totalValue = parseFloat(itemValues?.totalValue).toFixed(2)
                                    let totalCbm = parseFloat(itemValues?.totalCbm).toFixed(4)
                                    let totalWeight = parseFloat(itemValues?.totalWeight).toFixed(4)

                                    let availableQty = parseFloat(itemValues?.loadQty?.maxQty)

                                    let takenQty = availableQty - parseFloat(qty)
                                    takenQty.toFixed(0)

                                    // let displayQty = `${qty} - ${takenQty}`

                                    // getting the itemId container items
                                    // let containerItemValues = values?.containerItems.filter(i => i.itemId === itemValues?.id)

                                    // console.log('containerItemValues', containerItemValues, itemValues?.id)

                                    let _loadQty = itemValues?.loadQty?.inputQty ?
                                        itemValues.loadQty.inputQty
                                        :
                                        (itemValues.loadQty.maxQty === 0 && checkedSplitProductItems === false) ? 0 : ""

                                    return (

                                        <TableBody
                                            key={index}
                                        >
                                            {/* <TableRow>
                                                    <TableCell colSpan={7}>
                                                        {JSON.stringify(itemValues)}
                                                    </TableCell>
                                                </TableRow> */}
                                            <TableRow>
                                                <TableCell align="center">{(index + 1)}</TableCell>

                                                <TableCell>{itemValues?.remark}</TableCell>
                                                <TableCell>{itemValues?.description}</TableCell>
                                                <TableCell align="right">
                                                    {dimension?.length} x {dimension?.width} x {dimension?.height}
                                                </TableCell>
                                                <TableCell align="right">{weight}</TableCell>
                                                <TableCell align="right">{cbm}</TableCell>

                                                <TableCell align="right">{qty}</TableCell>

                                                <TableCell>

                                                    <TextField

                                                        disabled={
                                                            checkedSplitProductItems === false
                                                        }

                                                        margin="dense"
                                                        size="small"
                                                        // autoFocus
                                                        fullWidth
                                                        // name={`rows.${index}.qty`}
                                                        label=""
                                                        type="text"
                                                        variant="outlined"
                                                        sx={{
                                                            fontSize: 15,
                                                            p: 0
                                                        }}
                                                        value={
                                                            _loadQty
                                                        }
                                                        // onChange={handleChange}
                                                        onChange={(e) => {
                                                            setFieldValue(
                                                                `items.${index}.loadQty`,
                                                                {
                                                                    ...itemValues?.loadQty,
                                                                    inputQty: e.target.value
                                                                }
                                                            )
                                                        }}
                                                        error={Boolean(itemErrors?.loadQty?.inputQty)}
                                                        // helperText={itemErrors?.loadQty?.inputQty}
                                                        inputProps={{
                                                            style: {
                                                                p: 0,
                                                                fontSize: 15
                                                            }
                                                        }}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    {
                                                                        `/ ${itemValues?.loadQty.maxQty}`
                                                                    }
                                                                </InputAdornment>
                                                            ),
                                                            // style: {
                                                            //     padding: 1
                                                            // }
                                                        }}
                                                    />

                                                </TableCell>

                                            </TableRow>
                                        </TableBody>
                                    )


                                })
                            }

                        </Table>
                    </TableContainer>

                </Grid>

            </Grid>
        </Box >
    )
}

const RenderFormItemsMultiple = ({ t, formik, dataProducts, dataAvailableProducts, checkedSplitProductItems }) => {

    const { touched, errors, values, setFieldValue } = formik

    let rows = values.items

    // group by product id 
    let _productIds = []

    rows.forEach(i => {
        if (_productIds.includes(i.productId) === false) {
            _productIds.push(i.productId)
        }
    })

    const RenderProductSection = ({ productId, index }) => {

        let _data = rows.filter(i => i.productId === productId)

        // getting the product selected
        let _product = dataAvailableProducts.filter(i => i.id === productId)

        let _selectedProduct = _product.length > 0 ? _product[0] : {}

        let title = ``

        title = `${title} ${t("marking")}: ${_selectedProduct[productInjectionFields.customerMarking.retrieveKey]}`
        // title = `${title} / ${t("supplier")} : ${_selectedProduct[productInjectionFields.supplierName.retrieveKey]}`
        // title = `${title} / ${t("purchaseNo")} : ${_selectedProduct[productInjectionFields.companyPurchaseNumber.retrieveKey]}`
        // title = `${title} / ${t("courierNo")} : ${_selectedProduct[productInjectionFields.courierTrackingNo.retrieveKey]}`
        title = `${title} / ${t("totalCbm")} : ${_selectedProduct?.totalCbm}`
        title = `${title} / ${t("totalPackQty")} : ${_selectedProduct?.totalPackQty}`

        return (
            <>
                <TableHead>
                    <TableCell align="left" colSpan={8} sx={{ backgroundColor: grey[800] }}>
                        <Typography
                            sx={{
                                // fontWeight: 700,
                                color: grey[100],
                                // my: 1
                            }}
                        >
                            {`[${(index + 1)}] ${title}`}
                        </Typography>
                    </TableCell>
                </TableHead>
                <TableHead>
                    <TableRow>
                        <TableCell align="center">
                            {t('no')}
                        </TableCell>
                        <TableCell>{t('model')}</TableCell>
                        <TableCell>{t('itemName')}</TableCell>
                        <TableCell align="right">{t('dimension')}</TableCell>
                        <TableCell align="right">{t('weight')}</TableCell>
                        <TableCell align="right">{t('cbm')}</TableCell>

                        <TableCell align="right">{t('qty')}</TableCell>
                        <TableCell align="center" width={150}>{t('loadQty')}</TableCell>

                    </TableRow>
                </TableHead>
                {
                    _data.map((i, index) => {
                        return (
                            <RenderItems
                                key={`${i.productId}_${index}`}
                                index={index}
                                data={i}
                            />
                        )
                    })
                }
            </>
        )

    }

    const RenderItems = ({ data, index }) => {

        const itemValues = data;

        let pValues = dataProducts.filter(i => i.id === itemValues?.productId)

        let productValues = pValues.length ? pValues[0] : {}

        // console.log('itemValues', itemValues)

        let dimension = {
            width: parseFloat(itemValues?.width).toFixed(2),
            height: parseFloat(itemValues?.height).toFixed(2),
            length: parseFloat(itemValues?.length).toFixed(2)
        }

        // let handleQtyPerPackage = parseFloat(itemValues?.handleQtyPerPackage).toFixed(0)
        // let uomPrice = parseFloat(itemValues?.uomPrice).toFixed(2)
        // let handleQty = parseFloat(itemValues?.handleQty).toFixed(0)
        let weight = parseFloat(itemValues?.weight).toFixed(4)
        let qty = parseFloat(itemValues?.qty).toFixed(0)
        let cbm = parseFloat(itemValues?.cbm).toFixed(4)

        let totalValue = parseFloat(itemValues?.totalValue).toFixed(2)
        let totalCbm = parseFloat(itemValues?.totalCbm).toFixed(4)
        let totalWeight = parseFloat(itemValues?.totalWeight).toFixed(4)

        let availableQty = parseFloat(itemValues?.loadQty?.maxQty)

        let takenQty = availableQty - parseFloat(qty)
        takenQty.toFixed(0)

        let _loadQty = itemValues?.loadQty?.inputQty ?
            itemValues.loadQty.inputQty
            :
            (itemValues.loadQty.maxQty === 0 && checkedSplitProductItems === false) ? 0 : ""

        return (
            <TableBody
            // key={index}
            >
                <TableRow>
                    <TableCell align="center">{(index + 1)}</TableCell>

                    <TableCell>{itemValues?.remark}</TableCell>
                    <TableCell>{itemValues?.description}</TableCell>
                    <TableCell align="right">
                        {dimension?.length} x {dimension?.width} x {dimension?.height}
                    </TableCell>
                    <TableCell align="right">{weight}</TableCell>
                    <TableCell align="right">{cbm}</TableCell>

                    <TableCell align="right">{qty}</TableCell>

                    <TableCell>

                        <TextField

                            disabled
                            // disabled={
                            //     checkedSplitProductItems === false
                            // }

                            margin="dense"
                            size="small"
                            // autoFocus
                            fullWidth
                            // name={`rows.${index}.qty`}
                            label=""
                            type="text"
                            variant="outlined"
                            sx={{
                                fontSize: 15,
                                p: 0
                            }}
                            value={
                                _loadQty
                            }
                            // onChange={handleChange}
                            // onChange={(e) => {
                            //     setFieldValue(
                            //         `items.${index}.loadQty`,
                            //         {
                            //             ...itemValues?.loadQty,
                            //             inputQty: e.target.value
                            //         }
                            //     )
                            // }}
                            // error={Boolean(itemErrors?.loadQty?.inputQty)}
                            // helperText={itemErrors?.loadQty?.inputQty}
                            inputProps={{
                                style: {
                                    p: 0,
                                    fontSize: 15
                                }
                            }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        {
                                            `/ ${itemValues?.loadQty.maxQty}`
                                        }
                                    </InputAdornment>
                                ),
                                // style: {
                                //     padding: 1
                                // }
                            }}
                        />

                    </TableCell>

                </TableRow>
            </TableBody>
        )
    }

    return (
        <Box
            sx={{
                py: 1,
                px: 2
            }}
        >
            <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={12} alignSelf={"center"}
                    sx={{
                        "& .MuiTableCell-sizeSmall": {
                            // padding: "0" // <-- arbitrary value
                            px: 1,
                            py: 0
                        }
                    }}
                >
                    {/* {JSON.stringify(errors)} */}
                    <TableContainer
                    >
                        <Table
                            // sx={{ minWidth: 650 }}
                            sx={{
                                "& .MuiTableCell-root": {
                                    border: "1px solid rgba(224, 224, 224, 1)"
                                }
                            }}
                            size="small"
                            aria-label="a dense table"
                        >
                            {
                                _productIds.map((id, index) => {

                                    return (
                                        <>
                                            <RenderProductSection
                                                key={`${id}_${index}`}
                                                index={index}
                                                productId={id}
                                            />
                                        </>
                                    )


                                })
                            }

                        </Table>
                    </TableContainer>

                </Grid>

            </Grid>
        </Box >
    )
}

const RenderAvailableProducts = ({ t, getRoute, selectedIds, dataAvailableProducts, dataProducts, handleRowSelectionModelChange, availableLocations }) => {

    if (dataProducts.length <= 0) return <></>

    let columns = []

    let currentLocation = availableLocations.map(i => i?.location_name)

    if (currentLocation.includes('GZ')) {
        columns = getColumnsGZ({ t, getRoute })
    }
    else {
        columns = getColumnsDefault({ t, getRoute })
    }

    return (
        <>
            <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                <Divider>
                    {t('availableProducts')} ({`${dataProducts.length}`})
                </Divider>

            </Grid>
            <Grid item xs={12} sm={12} md={12}>
                <RenderFormProducts
                    t={t}
                    selectedIds={selectedIds}
                    columns={columns}
                    dataAvailableProducts={dataAvailableProducts}
                    handleRowSelectionModelChange={handleRowSelectionModelChange}
                />
            </Grid>
        </>
    )
}

const RenderSingleItemSelection = ({ t, formik, dataProducts, checkedSplitProductItems, handleChangeSplitProductItems }) => {

    const { values } = formik

    return (
        <>
            <Grid item xs={12} sm={12} md={6} textAlign={"left"} display={"flex"} justifyContent={"flex-start"} alignItems={"flex-end"}>

                {/* <Divider> */}
                <Typography
                    sx={{
                        px: 3
                    }}
                >
                    {t('availableItems')} ({`${values?.items.length}`})

                </Typography>
                {/* </Divider> */}

            </Grid>

            <Grid item xs={12} sm={12} md={6} textAlign={"right"}>

                <FormControlLabel
                    sx={{
                        mr: 3,
                        p: 0
                    }}
                    // required
                    control={
                        <Checkbox
                            checked={checkedSplitProductItems}
                            onChange={handleChangeSplitProductItems}
                        />
                    }
                    label={t('splitProductItems')}
                />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
                <RenderFormItems
                    t={t}
                    formik={formik}
                    dataProducts={dataProducts}
                    checkedSplitProductItems={checkedSplitProductItems}
                />
            </Grid>
        </>
    )
}

const RenderMultipleItemSelection = ({ t, formik, dataProducts, dataAvailableProducts, checkedSplitProductItems }) => {

    const { values } = formik

    return (
        <>
            <Grid item xs={12} sm={12} md={6} textAlign={"left"} display={"flex"} justifyContent={"flex-start"} alignItems={"flex-end"}>

                {/* <Divider> */}
                <Typography
                    sx={{
                        px: 3
                    }}
                >
                    {t('availableItems')} ({`${values?.items.length}`})

                </Typography>
                {/* </Divider> */}

            </Grid>

            {/* <Grid item xs={12} sm={12} md={6} textAlign={"right"}>

                <FormControlLabel
                    sx={{
                        mr: 3,
                        p: 0
                    }}
                    // required
                    control={
                        <Checkbox
                            checked={checkedSplitProductItems}
                            onChange={handleChangeSplitProductItems}
                        />
                    }
                    label={t('splitProductItems')}
                />
            </Grid> */}
            <Grid item xs={12} sm={12} md={12}>
                <RenderFormItemsMultiple
                    t={t}
                    formik={formik}
                    dataProducts={dataProducts}
                    dataAvailableProducts={dataAvailableProducts}
                    checkedSplitProductItems={checkedSplitProductItems}
                />
            </Grid>
        </>
    )
}

export default function AddContainerItems({
    routeType,
    containerId = '',
    handleOnSuccess = () => { }
}) {

    const { t } = useTranslations({ ns: ["_@repositories", "_@products", "_prompt", "common", "_common"] })

    const { getRoute } = useSystemRoutes(routeType);

    const [dataProducts, setDataProducts] = useState([])
    const [dataProductItems, setDataProductItems] = useState([])
    // const [searchKeyword, setSearchKeyword] = useState("")

    const { promptMessage } = useSystemPrompt();
    const { setSystemLoading } = useAppContextFeatures();

    const { getContainer } = useContainer({ routeType })
    const { listContainerItems, addContainerItem, addContainerItemBulk } = useContainerItem({ routeType })
    const { listProducts, filterOperatorTypes } = useProduct({ routeType })

    const { listProductItems } = useProductItem({ routeType })

    const { getAvailableLocations } = useAuthAccess();
    const availableLocations = getAvailableLocations()

    const [selectedIds, setSelectedIds] = useState([])

    const [containerLocationId, setContainerLocationId] = useState()

    const [checkedSplitProductItems, setCheckedSplitProductItems] = useState(false)
    const isSavingRef = useRef(false)

    const loadData = async (containerId) => {

        setSystemLoading(true)

        try {

            const data = await getContainer({ id: containerId })

            const {
                repository,
                // items, 
                // packing_file: packingFile 
            } = data;

            let dataContainer = {
                // ...initialValues,
                ...values?.container,
                locationId: repository?.location_id,
                locationName: repository?.location_name,
                toLocationId: repository?.to_location_id,
                toLocationName: repository?.to_location_name,
                repoNumber: repository?.repo_number,
                repoAlternativeNumber: repository?.number_alternative,
                numberSeal: repository?.number_seal,
                repoMarking: repository?.number_marking,
                initialDate: dayjs(repository?.repo_date),
                loadDate: dayjs(repository?.load_date),
                person: repository?.person,
                provider: repository?.provider,
                remark: repository?.remark ? repository.remark : "",

                sourceContainerRemId: repository[containerInjectionProps.sourceContainerRemId.retrieveKey]
                // ...initialRowValues,
                // packingFile,
                // rows,
            }

            setFieldValue(`container`, dataContainer)
            setContainerLocationId(repository?.location_id)
            // await fetchLocation(repository?.location_id)

        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)

    }

    const fetchProductsInPendingLoadByKeyword = async ({ keyword }) => {

        setSystemLoading(true)

        try {

            let filterValues = [
                {
                    name: productInjectionFields.customerMarking.retrieveKey,
                    operator: filterOperatorTypes.containsOr,
                    value: encodeURIComponent(keyword),
                    group: "name_group"
                },
                {
                    name: productInjectionFields.courierTrackingNo.retrieveKey,
                    operator: filterOperatorTypes.containsOr,
                    value: encodeURIComponent(keyword),
                    group: "name_group"
                },
                {
                    name: productInjectionFields.companyPurchaseNumber.retrieveKey,
                    operator: filterOperatorTypes.containsOr,
                    value: encodeURIComponent(keyword),
                    group: "name_group"
                },
                {
                    name: productInjectionFields.signedByUserDisplay.retrieveKey,
                    operator: filterOperatorTypes.containsOr,
                    value: encodeURIComponent(keyword),
                    group: "name_group"
                },
                {
                    name: productInjectionFields.supplierPurchaseNumber.retrieveKey,
                    operator: filterOperatorTypes.containsOr,
                    value: encodeURIComponent(keyword),
                    group: "name_group"
                },
                {
                    name: productInjectionFields.supplierName.retrieveKey,
                    operator: filterOperatorTypes.containsOr,
                    value: encodeURIComponent(keyword),
                    group: "name_group"
                },
                {
                    name: productInjectionFields.registerLocationId.retrieveKey,
                    operator: filterOperatorTypes.eq,
                    value: containerLocationId,
                    group: ""
                },
                {
                    name: productInjectionFields.loadStatus.retrieveKey,
                    operator: filterOperatorTypes.eq,
                    value: productLoadStatusTypes.pending.value,
                    group: ""
                },
                // {
                //     name: productInjectionFields.loadStatus.retrieveKey,
                //     // operator: filterOperatorTypes.isNullOr,
                //     operator: filterOperatorTypes.isNullOr,
                //     value: "",
                //     group: ""
                // },
            ]

            let dataTypes = [`${getInjectionDataType('product')}`, `${getInjectionDataType('item')}`]

            const props = {
                limit: 100,
                skip: 0,
                filterValue: filterValues,
                sortInfo: {
                    id: "id",
                    dir: -1
                },
                dataTypes
            }

            // props.itemType = itemTypes.product

            // const result = await listItems(props)
            const { data } = await listProducts({ props, dataTypes })

            // console.log('result?.data.products', JSON.stringify(data))

            setSystemLoading(false)

            return data

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

        setSystemLoading(false)

        return false

    }

    const fetchItems = async ({ productIds }) => {

        setSystemLoading(true)

        try {

            let dataTypes = [`${getInjectionDataType('item')}`]

            const props = {
                limit: -1,
                skip: 0,
                filterValue: [{
                    name: `product_id`,
                    operator: filterOperatorTypes.anyOf,
                    value: JSON.stringify(productIds)
                }],
                sortInfo: {
                    id: "id",
                    dir: 0
                },
                dataTypes
            }

            // props.itemType = itemTypes.item

            // const result = await listItems(props)
            const { data } = await listProductItems({ props, dataTypes })

            setSystemLoading(false)

            // console.log('data', data)

            let resultItems = data; // result?.data?.items ? result.data.items : []

            // console.log('resultItems, resultItems', JSON.stringify(resultItems))

            let dataItems = resultItems.map(i => {
                return {
                    ...initialItemValues,
                    productId: i?.product_id,
                    productName: i?.item_name,
                    itemId: i?.id,

                    code: i?.code,
                    description: i?.item_description,
                    remark: i?.item_remark,
                    uomId: i?.uom_id,
                    uomDisplay: i?.uom_name,
                    uomPrice: i?.uom_price,
                    width: i?.dimension_width,
                    length: i?.dimension_length,
                    height: i?.dimension_height,
                    weight: i?.net_weight,
                    qty: i[itemInjectionProps.packQty.retrieveKey],
                    handleQty: i[itemInjectionProps.handleQty.retrieveKey],
                    handleQtyPerPackage: i[itemInjectionProps.qtyPerPackage.retrieveKey],
                    cbm: i?.cbm,
                    totalValue: i[itemInjectionProps.totalValue.retrieveKey],
                    totalCbm: i[itemInjectionProps.totalCbm.retrieveKey],
                    totalWeight: i[itemInjectionProps.totalWeight.retrieveKey],
                }
            })

            let selectedItemIds = resultItems.map(i => i.id)

            // return result?.data.items
            // setDataItems()

            let containerItems = []

            if (selectedItemIds.length) {
                containerItems = await fetchContainerItems({ itemIds: selectedItemIds })
            }

            // console.log('containerItems', containerItems)

            // add in the load qty
            let newDataItems = dataItems.map(i => {

                let itemId = i?.itemId

                // console.log('containerItems', containerItems)
                let selected = containerItems.filter(i2 => i2.itemId === itemId)

                // console.log('selected, selected', selected, containerItems, i)

                let packQty = parseFloat(i?.qty)

                let loadQty = {
                    ...initialItemValues.loadQty,
                    maxQty: packQty,
                    inputQty: packQty
                }

                if (selected.length > 0) {

                    let takenQty = parseFloat(selected[0].takenQty)

                    let availableQty = packQty - takenQty

                    // console.log('availableQty, availableQty', availableQty, packQty, takenQty)

                    loadQty = {
                        ...loadQty,
                        maxQty: availableQty,
                        inputQty: availableQty
                    }

                }

                return {
                    ...i,
                    loadQty
                }
            })

            setFieldValue(`items`, newDataItems)

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

        setSystemLoading(false)

        return false

    }

    const fetchContainerItems = async ({ containerId = '', itemIds, rawResultOnly = false }) => {

        // setSystemLoading(true)

        // itemIds.push("22422")

        try {

            let filterValues = []

            filterValues.push({
                name: `item_id`,
                operator: filterOperatorTypes.anyOf,
                value: JSON.stringify(itemIds)
            })

            if (containerId) {
                filterValues.push({
                    name: `repository_id`,
                    operator: filterOperatorTypes.eq,
                    value: containerId
                })
            }

            const props = {
                limit: -1,
                skip: 0,
                filterValue: filterValues,
                sortInfo: {
                    id: "id",
                    dir: 0
                },
            }

            const { data } = await listContainerItems({ props, dataTypes: [`${getInjectionDataType('item')}`] })

            let resultContainerItems = data

            if (rawResultOnly === true) {
                return resultContainerItems
            }

            let resultContainerItemIds = []

            resultContainerItems.forEach(i => {
                if (resultContainerItemIds.includes(i?.item_id) === false) {
                    resultContainerItemIds.push(i?.item_id)
                }
            })

            let dataContainerItems = []

            // console.log('resultContainerItemIds, ', resultContainerItemIds)

            // group the result
            resultContainerItemIds.forEach(itemId => {

                let selected = resultContainerItems.filter(i => i.item_id === itemId)

                let qty = selected.reduce((total, item) => {
                    total += parseFloat(item?.qty)
                    return total
                }, 0)

                dataContainerItems.push({
                    itemId,
                    takenQty: qty
                })

            })

            // setFieldValue(`containerItems`, dataContainerItems)

            // console.log('dataContainerItems', dataContainerItems)

            return dataContainerItems

        } catch (error) {

            promptMessage(false, `Action Failed (${error?.message})`)
            return []
        }

        // setSystemLoading(false)

        // return false

    }

    const searchPendingProductsByKeyword = async ({ keyword }) => {

        let _dataProducts = await fetchProductsInPendingLoadByKeyword({ keyword })

        // console.log('_dataProducts', _dataProducts)

        setDataProducts(_dataProducts)

        // get the related items
        // let relatedItemIds = []

        // _dataProducts.forEach(i => {
        //     i?.items.forEach(i3 => {
        //         if (relatedItemIds.includes(i3?.id) === false) {
        //             relatedItemIds.push(i3?.id)
        //         }
        //     })
        // })

        // let relatedProductItems = []

        // if (relatedItemIds.length > 0) {
        //     relatedProductItems = await fetchProductItems({ itemIds: relatedItemIds })
        // }

        let relatedProductItems = []

        _dataProducts.forEach(i => {

            // console.log('1', i.items)
            // let _items = i.items.map(i2 => {
            //     return i2
            // })

            relatedProductItems = [...relatedProductItems, ...i.items]
        })

        // console.log('relatedProductItems', relatedProductItems)

        setDataProductItems(relatedProductItems)

    }

    const onSubmitSingleSelection = async (currentValues) => {

        setSystemLoading(true)

        try {

            // console.log('currentValues?.items', currentValues?.items)

            let inputs = currentValues?.items.map(i => {
                return {
                    itemId: i.itemId,
                    loadQty: {
                        inputQty: i.loadQty.inputQty,
                        maxQty: i.loadQty.maxQty
                    }
                }
            })

            let productId = selectedIds[0]
            let containerSourceRemId = values?.container?.sourceContainerRemId

            let needToSplit = checkedSplitProductItems;

            await addContainerItem({
                productId,
                inputs,
                // totalInputQty,
                // totalMaxQty,
                // loadContainerDateTime: _loadContainerDateTime = dayjs().format("YYYY-MM-DD HH:mm:ss"),
                needToSplit: Boolean(needToSplit),
                containerId,
                containerSourceRemId
            })

            promptMessage(true, `${t("productAddedToContainer")}`)

            resetMainForm()

        } catch (error) {
            promptMessage(false, t(error))
        }

        setSystemLoading(false)

    }

    const onSubmitMultipleSelection = async (currentValues) => {
        // console.log('cu', currentValues)

        setSystemLoading(true)

        try {

            let products = dataProducts.filter(i => selectedIds.includes(i.id))

            // let productIds = selectedIds
            let containerSourceRemId = values?.container?.sourceContainerRemId

            // set the base loadContainerDatetime
            const loadContainerDateTime = dayjs().format("YYYY-MM-DD HH:mm:ss")

            await addContainerItemBulk({
                // productIds,
                products,
                loadContainerDateTime,
                containerId,
                containerSourceRemId
            })

            promptMessage(true, `${t("productAddedToContainerBulk")}`)

            resetMainForm()


        } catch (error) {
            promptMessage(false, t(error))
        }

        setSystemLoading(false)

    }

    const resetMainForm = () => {
        // clear the settings
        setSelectedIds([])

        // console.log('container', values?.container)

        setFieldValue(`items`, [])

        setDataProducts([])
        setDataProductItems([])
        // setDataProductContainerItems([])

        setCheckedSplitProductItems(false)

        if (handleOnSuccess) handleOnSuccess()
    }

    const onSubmit = async (currentValues) => {

        // console.log('currentValues', currentValues)

        // A second click while the first save is still running loads and splits the product twice.
        if (isSavingRef.current) return
        isSavingRef.current = true

        setSystemLoading(true)

        try {

            if (selectedIds.length === 1) {
                await onSubmitSingleSelection(currentValues)

                // setSystemLoading(false)

                // promptMessage(true, `${t("productAddedToContainer")}`)

            }

            if (selectedIds.length > 1) {
                await onSubmitMultipleSelection(currentValues)

                // // clear the settings
                // setSelectedIds([])

                // // console.log('container', values?.container)

                // setFieldValue(`items`, [])

                // setDataProducts([])
                // setDataProductItems([])
                // // setDataProductContainerItems([])

                // setCheckedSplitProductItems(false)

                // if (handleOnSuccess) handleOnSuccess()

                // setSystemLoading(false)

                // promptMessage(true, `${t("productAddedToContainerInBulk")}`)
            }


        } catch (error) {
            promptMessage(false, `Action Failed. (${error?.message})`)
            setSystemLoading(false)
        } finally {
            isSavingRef.current = false
        }

        // return true
    }

    const formikSearch = useFormik({
        initialValues: initialSearchValues,
        validationSchema: validationSearchSchema,
        enableReinitialize: true,
        onSubmit: (currentValues) => {

            setFieldValue(`container.marking`, "")
            setFieldValue(`items`, [])
            setFieldValue(`containerItems`, [])
            setSelectedIds([])

            // search pending products
            searchPendingProductsByKeyword({ keyword: currentValues?.keyword })

        }
    });

    const formik = useFormik({
        initialValues,
        validationSchema: validateSchema,
        enableReinitialize: true,
        onSubmit
    });

    const { values, errors, touched, handleChange, setFieldValue, handleSubmit } = formik;

    useEffect(() => {

        loadData(containerId);

    }, [])

    useEffect(() => {

        if (selectedIds.length > 0) {
            fetchItems({ productIds: selectedIds })
        }

    }, [selectedIds])

    useEffect(() => {

        // console.log('checkedSplitProductItems', checkedSplitProductItems, values.items)

        // for disable split - set the input qty into maxQty
        if (checkedSplitProductItems === false) {

            setFieldValue(
                `items`,
                values.items.map(i => {
                    return {
                        ...i,
                        loadQty: {
                            ...i.loadQty,
                            inputQty: i?.loadQty.maxQty
                        }
                    }
                })
            )

        } else {
            // for enable split - set the input qty into 0
            setFieldValue(
                `items`,
                values.items.map(i => {
                    return {
                        ...i,
                        loadQty: {
                            ...i.loadQty,
                            inputQty: ""
                        }
                    }
                })
            )
        }


    }, [checkedSplitProductItems])

    const getSaveDisableStatus = () => {

        if (selectedIds.length <= 0) return true

        // console.log('errors', errors)
        return Object.keys(errors).length > 0
    }

    let dataAvailableProducts = []

    dataProducts.forEach(i => {

        let totalCbm = 0;
        let totalValues = 0;
        let totalWeight = 0;
        let totalPackQty = 0
        // let totalPackQtyInThisContainer = 0

        i?.items.forEach(i2 => {

            let itemId = i2?.id
            let selected = dataProductItems.filter(i5 => i5.id === itemId)

            if (selected.length > 0) {

                let packQty = selected[0][itemInjectionProps.packQty.retrieveKey]
                let cbm = selected[0]?.cbm
                let handleQty = selected[0][itemInjectionProps.handleQty.retrieveKey]
                let uomPrice = selected[0]?.uom_price
                let weight = selected[0]?.net_weight

                totalPackQty += parseFloat(packQty)
                totalCbm += parseFloat(cbm) * parseFloat(packQty)
                totalWeight += parseFloat(weight) * parseFloat(packQty)
                totalValues += parseFloat(handleQty) * parseFloat(uomPrice)
            }

            // // check the item is in this container
            // let selected2 = dataProductContainerItems.filter(i5 => i5.itemId === itemId)

            // console.log('dataProductContainerItems', dataProductContainerItems)
            // // console.log('selected', i2?.id, dataProductContainerItems)

            // let packQtyInThisContainer = 0

            // selected2.forEach(i7 => {

            //     if (selected.length > 0) {
            //         let packQty = selected[0][itemInjectionProps.packQty.retrieveKey]
            //         packQtyInThisContainer += parseFloat(packQty)
            //     }

            // })

            // totalPackQtyInThisContainer += packQtyInThisContainer

        })

        totalCbm = totalCbm.toFixed(4)
        totalPackQty = totalPackQty.toFixed(0)
        totalValues = totalValues.toFixed(2)
        totalWeight = totalWeight.toFixed(4)
        // totalPackQtyInThisContainer = totalPackQtyInThisContainer.toFixed(0)

        dataAvailableProducts.push({
            ...i,
            totalCbm,
            totalPackQty,
            totalValues,
            totalWeight
            // totalPackQtyInThisContainer
        })

    })

    // console.log('dataAvailableProducts', dataAvailableProducts)

    const handleRowSelectionModelChange = (ids) => {
        // console.log('props', ids)

        const selectedIDs = new Set(ids);
        const selectedRowData = dataAvailableProducts.filter((row) => selectedIDs.has(row.id.toString()))

        // console.log(selectedRowData);

        // if (ids.length > 1) {
        //     promptMessage(false, t('onlySelect1ProductToProceed'))
        //     return false
        // }

        let _ids = []
        let failedIdentifiers = []

        selectedRowData.forEach(i => {

            let totalPackQty = i?.items.reduce((i2, total) => {
                total += parseInt(i2[itemInjectionProps.packQty.retrieveKey], 10)
                return total
            }, 0)

            if (i[productInjectionFields.loadStatus.retrieveKey] === productLoadStatusTypes.loaded.value) {
                failedIdentifiers.push(`${t('selectedProductHasBeenLoadedToContainer')} (Id: ${i.id} (CBM: ${i?.totalCbm})`)
            } else if (totalPackQty <= 0) {
                failedIdentifiers.push(`${t('packQtyZero')} (Id: ${i.id} (Total Pack Qty: ${totalPackQty})`)
            } else {
                _ids.push(i.id)
            }

        })

        // console.log('sfds', _ids, ids)

        if (failedIdentifiers.length > 0) {
            promptMessage(false, `${failedIdentifiers.join(', ')}`)
            // return false
        }

        // if (selectedRowData.length > 0) {
        //     let a = selectedRowData[0]

        //     if (a[productInjectionFields.loadStatus.retrieveKey] === productLoadStatusTypes.loaded.value) {
        //         promptMessage(false, t('selectedProductHasBeenLoadedToContainer'))
        //         return false
        //     }
        // }

        // set default unsplit option
        if (_ids.length > 1) {
            setCheckedSplitProductItems(false)
        }

        setSelectedIds(_ids)
        return true
    }

    return (
        <Box>

            {/* {JSON.stringify(values?.container)} */}
            {/* {
                JSON.stringify(values)
            } */}
            <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                    <RenderFormSearchMarking
                        t={t}
                        formik={formikSearch}
                    />

                </Grid>
            </Grid>

            <form onSubmit={handleSubmit}>

                <Grid container spacing={1}>

                    <RenderAvailableProducts
                        t={t}
                        selectedIds={selectedIds}
                        getRoute={getRoute}
                        // columns={getColumns()}
                        dataAvailableProducts={dataAvailableProducts}
                        dataProducts={dataProducts}
                        handleRowSelectionModelChange={handleRowSelectionModelChange}
                        availableLocations={availableLocations}
                    />

                    {
                        // for single selection for item - to add normal or split normal
                        (selectedIds.length === 1) &&

                        <RenderSingleItemSelection
                            t={t}
                            formik={formik}
                            dataProducts={dataProducts}
                            checkedSplitProductItems={checkedSplitProductItems}
                            handleChangeSplitProductItems={(e) => {

                                let a = e.currentTarget.checked

                                // check the product items selected must have more than 0 cbm
                                let totalSelectedCbm = 0

                                let selectedProduct = dataProducts.filter(i => selectedIds.includes(i.id))

                                selectedProduct.forEach((i) => {
                                    let totalCbm = i?.items.reduce((total, i2) => {
                                        let a = total + parseFloat(i2.cbm)
                                        return a
                                    }, 0)
                                    totalSelectedCbm += totalCbm
                                })

                                // console.log('handleChangeSplitProductItems', selectedProduct, totalSelectedCbm)

                                // if (totalSelectedCbm <= 0) {
                                //     promptMessage(false, `CBM must more than 0`)
                                //     return false
                                // }

                                setCheckedSplitProductItems(a)
                                return true

                            }}
                        />
                    }

                    {
                        // for multiple selection for item - only allow to add normal / cannot split
                        (selectedIds.length > 1) &&

                        <RenderMultipleItemSelection
                            t={t}
                            formik={formik}
                            dataProducts={dataProducts}
                            dataAvailableProducts={dataAvailableProducts}
                            checkedSplitProductItems={checkedSplitProductItems}
                        // handleChangeSplitProductItems={(e) => {
                        //     let a = e.currentTarget.checked
                        //     setCheckedSplitProductItems(a)
                        // }}
                        />
                    }

                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <Divider />

                    </Grid>

                    <Grid item xs={12} sm={12} md={12} textAlign={"right"} sx={{ px: 2 }}>
                        <Button
                            type="submit"
                            variant="contained"
                            disabled={
                                getSaveDisableStatus() || formik.isSubmitting
                            }
                            sx={{
                                mt: 3,
                                mb: 2
                            }}
                        >
                            {t('saveChanges')}
                        </Button>
                    </Grid>
                </Grid>

            </form>

            {/* {
                isPermissionAllow({ functionType: functionTypes.pageUpdate.id }) ?
                    RenderForm()
                    :
                    <CommonRestricted />
            } */}

        </Box>
    )
}